<template>
    <!-- PC提现明细 -->
    <ZhaiHeadPC class="zhai-head" />

    <div class="container errong">
        <!-- 顶部栏：只保留推广中心 + 中间标题 -->
        <div class="container-fluid mt-3">
            <div class="row shengse mt-2">
                <div class="dixian px-3 py-2 top-bar-pc">
                    <div class="left promo-title lf" @click="goBack">
                        <i class="fa fa-bullhorn"></i> 推广中心
                    </div>
                </div>
            </div>
        </div>

        <!-- 主体 -->
        <div class="wd-body">
            <div class="wd-shell">
                <!-- ✅ 重新设计：主体顶部“页头工具条”（把我的钱包放这里） -->
                <div class="page-head">
                    <div class="ph-left">
                        <div class="ph-title">提现明细</div>
                        <div class="ph-sub">查看你的提现记录与状态</div>
                    </div>

                    <div class="ph-right">
                        <button class="btn-soft" @click="goMyWallet">
                            <i class="fa fa-rmb"></i> 我的钱包
                        </button>
                    </div>
                </div>

                <!-- 筛选条（更轻量） -->
                <div class="filter-bar">
                    <div class="fb-left">
                        <span class="fb-label">状态</span>
                        <select class="select" v-model="statusFilter" @change="reload">
                            <option value="">全部</option>
                            <option value="0">待审核</option>
                            <option value="1">处理中</option>
                            <option value="2">已到账</option>
                            <option value="3">失败</option>
                        </select>
                        <span class="fb-meta">共 {{ total }} 条</span>
                    </div>

                    <div class="fb-right">
                        <button class="btn-outline" :disabled="loading || pageChanging" @click="reload">
                            刷新
                        </button>
                    </div>
                </div>

                <!-- 内容区 -->
                <div class="content-wrap">
                    <!-- 骨架屏 -->
                    <div v-if="loading" class="grid">
                        <div class="card skeleton-card" v-for="i in 8" :key="i">
                            <div class="skeleton-row">
                                <div class="skeleton-block w-40"></div>
                                <div class="skeleton-block w-20"></div>
                            </div>
                            <div class="skeleton-row">
                                <div class="skeleton-block w-55"></div>
                                <div class="skeleton-block w-25"></div>
                            </div>
                            <div class="skeleton-row">
                                <div class="skeleton-block w-70"></div>
                            </div>
                        </div>
                    </div>

                    <!-- 错误态 -->
                    <div v-else-if="error" class="card state-card">
                        <div class="state-title">加载失败</div>
                        <div class="state-desc">{{ error }}</div>
                        <button class="btn-primary" @click="reload">点击重试</button>
                    </div>

                    <!-- 空状态 -->
                    <div v-else-if="records.length === 0" class="card empty-card">
                        <div class="empty-line">
                            <span class="line"></span>
                            <span class="text">我是有底线的</span>
                            <span class="line"></span>
                        </div>
                    </div>

                    <!-- 列表：更像PC（两列卡片网格），不做大表格 -->
                    <div v-else class="grid">
                        <div class="card record-card" v-for="item in records" :key="item.id">
                            <div class="rc-top">
                                <div class="rc-left">
                                    <div class="rc-title">
                                        提现
                                        <span class="badge" :class="statusClass(item.status)">{{ statusText(item.status) }}</span>
                                    </div>
                                    <div class="rc-sub">到账方式：{{ item.channel || "—" }}</div>
                                </div>

                                <div class="rc-right">
                                    <div class="money neg">-{{ formatMoney(item.amount) }}</div>
                                    <div class="time">{{ formatTimeToSecond(item.time) }}</div>
                                </div>
                            </div>

                            <div class="divider"></div>

                            <div class="rc-meta">
                                <div class="meta-row">
                                    <span class="k">单号</span>
                                    <span class="v mono" :title="item.orderNo || ''">{{ item.orderNo || "—" }}</span>
                                </div>
                                <div class="meta-row">
                                    <span class="k">备注</span>
                                    <span class="v ellipsis" :title="item.remark || ''">{{ item.remark || "—" }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 分页 -->
                    <div class="pager-wrap" v-if="!loading && !error && totalPages > 1">
                        <div class="pager">
                            <button class="pager-btn" :disabled="page === 1 || pageChanging" @click="goPage(page - 1)">«</button>

                            <button
                                    class="pager-btn"
                                    :class="{ active: page === 1 }"
                                    :disabled="pageChanging"
                                    @click="goPage(1)"
                            >
                                1
                            </button>

                            <template v-if="totalPages >= 3">
                                <template v-if="page > 1 && page < totalPages">
                                    <button class="pager-btn dots" disabled>…</button>
                                    <button class="pager-btn active" disabled>{{ page }}</button>
                                    <button class="pager-btn dots" disabled>…</button>
                                </template>
                                <template v-else>
                                    <button class="pager-btn dots" disabled>…</button>
                                </template>
                            </template>

                            <button
                                    class="pager-btn"
                                    :class="{ active: page === totalPages }"
                                    :disabled="pageChanging"
                                    @click="goPage(totalPages)"
                            >
                                {{ totalPages }}
                            </button>

                            <button class="pager-btn" :disabled="page === totalPages || pageChanging" @click="goPage(page + 1)">»</button>
                        </div>

                        <div class="pager-loading" v-if="pageChanging">加载中…</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="gongxi2"></div>
    <ZhaiFootPC />
</template>

<script>
    import ZhaiHeadPC from "../componentspc/ZhaiHeadPC";
    import ZhaiFootPC from "../componentspc/ZhaiFootPC";
    import http from "@/utils/http";

    export default {
        name: "PWithdrawalDetails",
        components: { ZhaiHeadPC, ZhaiFootPC },

        data() {
            return {
                // 状态
                loading: true,
                pageChanging: false,
                error: "",

                // 列表数据（渲染用）
                records: [],

                // 分页
                page: 1,
                pageSize: 10,
                total: 0,

                // 筛选
                statusFilter: "",

                // 参考同项目：更稳的 userId（vuex可能未就绪）
                currentUserId: null,
            };
        },

        computed: {
            totalPages() {
                const t = Number(this.total || 0);
                const s = Number(this.pageSize || 10);
                return Math.max(1, Math.ceil(t / s));
            },
        },

        // ✅ 路由守卫：未登录直接跳登录页（同 Promotion）
        beforeRouteEnter(to, from, next) {
            const token = localStorage.getItem("token");
            if (!token) next("/login");
            else next();
        },

        async mounted() {
            // ✅ mounted 再兜一次（同 Promotion）
            const token = localStorage.getItem("token");
            if (!token) {
                if (this.$router) this.$router.replace("/login");
                else window.location.href = "/login";
                return;
            }

            // ✅ 更稳的 userId 获取（同 Promotion 思路）
            this.currentUserId = this.resolveUserIdSafe();

            // 拉列表
            await this.fetchList(true);
        },

        methods: {
            // ================== 路由跳转（保留你的习惯） ==================
            goBack() {
                if (this.$router) this.$router.push("/Promotion");
                else window.location.href = "/Promotion";
            },
            goMyWallet() {
                if (this.$router) this.$router.push("/MyWallet");
                else window.location.href = "/MyWallet";
            },
            toSetting() {
                if (this.$router) this.$router.push("/WalletSettings");
                else window.location.href = "/WalletSettings";
            },

            // ================== 工具：更稳的 userId 获取（参考 Promotion） ==================
            resolveUserIdSafe() {
                // 1) localStorage 常见存法
                const tryKeys = ["user", "userinfo", "userInfo", "USER", "User"];
                for (const k of tryKeys) {
                    try {
                        const raw = localStorage.getItem(k);
                        if (!raw) continue;
                        const obj = JSON.parse(raw);

                        if (obj && obj.id) return obj.id;
                        if (obj && obj.data && obj.data.id) return obj.data.id;
                    } catch (e) {
                        // ignore
                    }
                }

                // 2) 如果你项目还有别的 key（比如 uid），可以加这里
                // const uid = localStorage.getItem("uid");
                // if (uid) return Number(uid);

                return null;
            },

            // ================== 工具：到账方式展示 ==================
            methodText(m) {
                const map = { 1: "USDT", 2: "支付宝", 3: "银行卡" };
                return map[m] || "—";
            },

            // ================== 工具：金额格式 ==================
            formatMoney(v) {
                const n = Number(v || 0);
                return n.toFixed(2);
            },

            // ================== 状态展示 ==================
            statusText(s) {
                const map = { 0: "待审核", 1: "处理中", 2: "已到账", 3: "失败" };
                return map[s] || "未知";
            },
            statusClass(s) {
                return {
                    pending: s === 0,
                    doing: s === 1,
                    success: s === 2,
                    fail: s === 3,
                };
            },
            formatTimeToSecond(v) {
                if (!v) return "—";

                try {
                    // 字符串：直接截到秒
                    if (typeof v === "string" && v.length >= 19) {
                        return v.substring(0, 19).replace("T", " ");
                    }

                    const d = new Date(v);
                    if (isNaN(d.getTime())) return "—";

                    const pad = (n) => String(n).padStart(2, "0");
                    return (
                        d.getFullYear() +
                        "-" +
                        pad(d.getMonth() + 1) +
                        "-" +
                        pad(d.getDate()) +
                        " " + // 👈 这里原来是 "T"
                        pad(d.getHours()) +
                        ":" +
                        pad(d.getMinutes()) +
                        ":" +
                        pad(d.getSeconds())
                    );
                } catch (e) {
                    return "—";
                }
            },

            // ================== 核心：拉取提现列表（按你 Postman 返回结构） ==================
            async fetchList(reset = false) {
                try {
                    if (reset) {
                        this.loading = true;
                        this.error = "";
                    } else {
                        this.pageChanging = true;
                        this.error = "";
                    }

                    // ✅ 后端入参是 status/page/pageSize/userId
                    const params = {
                        page: this.page,
                        pageSize: this.pageSize,
                        status: this.statusFilter === "" ? undefined : Number(this.statusFilter),
                    };

                    // ✅ 参考 Promotion：有 userId 就传（更稳）
                    if (this.currentUserId) {
                        params.userId = this.currentUserId;
                    }

                    const res = await http.get("/platform/withdraw/myList", params);
                    const json = res && res.data ? res.data : null;

                    // ✅ 后端成功：status === 1（你 Postman 已验证）
                    if (!json || Number(json.status) !== 1) {
                        const msg = (json && json.msg) || "加载失败";

                        // ✅ 如果后端提示未登录，直接跳登录（同 Promotion 体验）
                        if (msg.includes("未登录") || msg.includes("登录")) {
                            if (this.$router) this.$router.replace("/login");
                            else window.location.href = "/login";
                            return;
                        }

                        throw new Error(msg);
                    }

                    const data = json.data || {};
                    const list = Array.isArray(data.list) ? data.list : [];

                    // ✅ 把后端字段映射成你模板使用的字段：amount/time/channel
                    this.records = list.map((x) => {
                        const amountCent = Number(x.amountCent || 0);
                        const amount = amountCent / 100;

                        return {
                            id: x.id,
                            status: x.status,
                            orderNo: x.orderNo,
                            remark: x.remark,

                            // 下面三个是你 template 用到的字段名
                            amount,                 // template: formatMoney(item.amount)
                            time: x.createdAt,      // template: item.time
                            channel: this.methodText(x.method), // template: item.channel
                        };
                    });

                    this.total = Number(data.total || 0);

                    // ✅ 防御：如果当前页超过总页数，自动回到最后一页
                    const tp = this.totalPages;
                    if (this.page > tp) {
                        this.page = tp;
                        await this.fetchList(false);
                    }
                } catch (e) {
                    this.error = e && e.message ? e.message : "网络异常，请稍后再试";
                } finally {
                    this.loading = false;
                    this.pageChanging = false;
                }
            },

            // ================== 分页 ==================
            async goPage(p) {
                const pageNum = Number(p);
                if (!pageNum || pageNum < 1 || pageNum > this.totalPages) return;
                if (pageNum === this.page) return;
                if (this.loading || this.pageChanging) return;

                this.page = pageNum;
                await this.fetchList(false);
            },

            // ================== 刷新/筛选 ==================
            reload() {
                this.page = 1;
                this.fetchList(true);
            },
        },
    };
</script>

<style scoped>
    /* ====== 基础 ====== */
    body { font-family: Arial, sans-serif; }
    .fa { margin-right: 6px; }
    .lf {
        font-weight: 900;
    }
    .gongxi2 { height: 20px; }

    .errong { padding-left: 30px; padding-right: 30px; }
    @media (min-width: 768px) {
        .zhai-head { position: fixed; top: 0; width: 100%; z-index: 1000; }
        .errong { margin-top: 80px; }
    }

    /* ====== 顶部栏（保持简洁） ====== */
    .top-bar-pc{
        display:grid;
        grid-template-columns:1fr auto 1fr;
        align-items:center;
    }
    .promo-title{
        cursor:pointer;
        user-select:none;
        font-size:15px;
        color:#333;
        display:inline-flex;
        align-items:center;
    }
    .promo-title:active{ opacity:.75; }

    /* ====== 主体壳 ====== */
    .wd-body{
        background:#f3f4f6;
        border-radius:2px;
        margin-top:10px;
    }
    .wd-shell{
        max-width:1200px;
        margin:0 auto;
        /*padding:16px;*/
    }

    /* ====== 新设计：页头工具条（关键） ====== */
    .page-head{
        display:flex;
        align-items:center;
        justify-content:space-between;
        gap:12px;
        padding:14px 14px;
        background:#fff;
        border:1px solid #eee;
        border-radius:2px;
    }
    .ph-left{ min-width:0; }
    .ph-title{
        font-size:16px;
        font-weight:900;
        color:#111;
    }
    .ph-sub{
        margin-top:6px;
        font-size:13px;
        color:#888;
    }
    .ph-right{
        display:flex;
        gap:10px;
        flex-wrap:wrap;
    }
    .btn-soft{
        height:36px;
        padding:0 12px;
        border-radius:2px;
        border:1px solid #eee;
        background:#fafafa;
        font-size:13px;
        cursor:pointer;
        color:#333;
        display:inline-flex;
        align-items:center;
    }
    .btn-soft .fa{ margin-right:8px; color:#00c26f; }
    .btn-soft:active{ opacity:.8; }

    /* ====== 筛选条 ====== */
    .filter-bar{
        margin-top:10px;
        padding:10px 12px;
        background:#fff;
        border:1px solid #eee;
        border-radius:2px;
        display:flex;
        align-items:center;
        justify-content:space-between;
        gap:12px;
    }
    .fb-left{
        display:flex;
        align-items:center;
        gap:10px;
        flex-wrap:wrap;
    }
    .fb-label{
        font-size:13px;
        color:#666;
        font-weight:900;
    }
    .fb-meta{
        font-size:13px;
        color:#999;
    }
    .select{
        height:34px;
        border-radius:2px;
        border:1px solid #e9e9e9;
        padding:0 10px;
        font-size:13px;
        outline:none;
        background:#fff;
    }
    .fb-right{ display:flex; align-items:center; gap:10px; }

    /* ====== 内容区 ====== */
    .content-wrap{ margin-top:12px; }

    /* 卡片通用（2px） */
    .card{
        background:#fff;
        border:1px solid #eee;
        border-radius:2px;
        box-shadow:0 6px 16px rgba(0,0,0,.04);
        padding:12px;
    }

    /* 列表网格（更像PC） */
    .grid{
        display:grid;
        grid-template-columns:repeat(2, 1fr);
        gap:12px;
    }
    @media (max-width: 992px){
        .grid{ grid-template-columns:1fr; }
    }

    /* 记录卡 */
    .record-card{ padding:14px; }
    .rc-top{
        display:flex;
        justify-content:space-between;
        gap:12px;
    }
    .rc-left{ flex:1; min-width:0; }
    .rc-title{
        display:flex;
        align-items:center;
        gap:8px;
        font-size:15px;
        font-weight:900;
        color:#111;
    }
    .rc-sub{
        margin-top:6px;
        font-size:12px;
        color:#888;
    }
    .rc-right{ text-align:right; flex-shrink:0; }
    .money{
        font-size:18px;
        font-weight:900;
        color:#111;
        line-height:1.2;
    }
    .money.neg{ color:#ff4d4f; }
    .time{
        margin-top:6px;
        font-size:12px;
        color:#9a9a9a;
    }
    .divider{
        height:1px;
        background:#f0f0f0;
        margin:12px 0;
    }
    .rc-meta .meta-row{
        display:flex;
        align-items:center;
        justify-content:space-between;
        gap:10px;
        padding:6px 0;
        font-size:13px;
    }
    .k{ color:#8a8a8a; flex-shrink:0; }
    .v{ color:#333; text-align:right; flex:1; }
    .mono{
        font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    }
    .ellipsis{
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap;
    }

    /* 状态徽标 */
    .badge{
        font-size:12px;
        font-weight:900;
        padding:3px 8px;
        border-radius:999px;
        border:1px solid transparent;
    }
    .badge.pending{ color:#d48806; background:#fff7e6; border-color:#ffe7ba; }
    .badge.doing{ color:#0958d9; background:#e6f4ff; border-color:#bae0ff; }
    .badge.success{ color:#1f8a4c; background:#e9fff1; border-color:#b7eb8f; }
    .badge.fail{ color:#cf1322; background:#fff1f0; border-color:#ffccc7; }

    /* 错误/空状态 */
    .state-card{ text-align:center; padding:26px 12px; }
    .state-title{ font-size:16px; font-weight:900; color:#111; margin-bottom:8px; }
    .state-desc{ font-size:13px; color:#777; margin-bottom:12px; }
    .empty-card{ padding:26px 12px; }
    .empty-line{
        width:100%;
        display:flex;
        align-items:center;
        justify-content:center;
        color:#9b9b9b;
        font-size:14px;
    }
    .empty-line .line{ width:140px; height:1px; background:#e9e9e9; margin:0 14px; }
    .empty-line .text{ white-space:nowrap; }

    /* 按钮（2px圆角） */
    .btn-primary{
        height:36px;
        padding:0 14px;
        border-radius:2px;
        border:none;
        cursor:pointer;
        font-size:13px;
        font-weight:900;
        color:#fff;
        background:linear-gradient(90deg,#ff4d4f,#ff7a6a);
    }
    .btn-outline{
        height:34px;
        padding:0 12px;
        border-radius:2px;
        border:1px solid #e9e9e9;
        background:#fff;
        font-size:13px;
        cursor:pointer;
        color:#333;
    }
    .btn-outline:disabled{ opacity:.55; cursor:not-allowed; }
    .btn-outline:active:not(:disabled){ opacity:.8; }

    /* 骨架屏 */
    .skeleton-card{ border-radius:2px; }
    .skeleton-row{ display:flex; justify-content:space-between; gap:10px; margin-bottom:10px; }
    .skeleton-block{
        height:12px;
        border-radius:2px;
        background:linear-gradient(90deg,#f3f3f3 25%,#ececec 37%,#f3f3f3 63%);
        background-size:400% 100%;
        animation:shimmer 1.2s ease-in-out infinite;
    }
    .w-20{ width:20%; } .w-25{ width:25%; } .w-40{ width:40%; } .w-55{ width:55%; } .w-70{ width:70%; }
    @keyframes shimmer{ 0%{ background-position:100% 0; } 100%{ background-position:0 0; } }

    /* 分页器 */
    .pager-wrap{
        padding:14px 0 6px;
        display:flex;
        flex-direction:column;
        align-items:center;
    }
    .pager{
        display:inline-flex;
        align-items:center;
        border-radius:2px;
        overflow:hidden;
        border:1px solid #e6e6e6;
        background:#fff;
    }
    .pager-btn{
        min-width:34px;
        height:32px;
        padding:0 10px;
        border:0;
        border-right:1px solid #e6e6e6;
        background:#fff;
        color:#333;
        font-size:18px;
        line-height:32px;
        text-align:center;
        cursor:pointer;
        user-select:none;
    }
    .pager-btn:last-child{ border-right:0; }
    .pager-btn:disabled{ opacity:.45; cursor:not-allowed; }
    .pager-btn.active{ color:#00c26f; font-weight:900; background:#f3fff8; }
    .pager-btn.dots{ cursor:default; font-weight:900; }
    .pager-btn:active:not(:disabled):not(.dots){ opacity:.75; }
    .pager-loading{ margin-top:8px; font-size:12px; color:#9a9a9a; }
</style>
